module.exports = __webpack_public_path__ + "img/jcb-icon.9da3197b.svg";